'use client';

import { ReactNode } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { FilledArrowRight } from '../../../common/svgIcons';

type StyleOverride = Parameters<typeof css>[0];

export const iconCircleStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: 'neutrals.fill_quinary',
});

const baseContainerStyles: StyleOverride = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0',
};

const baseIconRowStyles: StyleOverride = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'small',
  mb: 'small',
};

const baseTitleStyles: StyleOverride = {
  fontSize: 'display.large_medium',
  fontWeight: 'display.large_medium',
  lineHeight: 'display.large_medium',
  letterSpacing: 'display.large_medium',
  color: 'neutrals.text_primary',
  textAlign: 'center',
  mb: 'small',
};

const baseSubtitleStyles: StyleOverride = {
  fontSize: 'title.large_medium',
  fontWeight: 'title.large_medium',
  lineHeight: 'title.large_medium',
  letterSpacing: 'title.large_medium',
  color: 'neutrals.text_secondary',
  textAlign: 'center',
};

export interface TwoIconsWithTextProps {
  leftIcon: ReactNode;
  rightIcon?: ReactNode;
  title?: string;
  subtitle?: string;
  containerStyles?: StyleOverride;
  iconsStyles?: StyleOverride;
  leftIconStyles?: StyleOverride;
  titleStyles?: StyleOverride;
  subtitleStyles?: StyleOverride;
}

export const TwoIconsWithText = ({
  leftIcon,
  rightIcon,
  title,
  subtitle,
  containerStyles: containerOverride,
  iconsStyles: iconsOverride,
  leftIconStyles: leftIconOverride,
  titleStyles: titleOverride,
  subtitleStyles: subtitleOverride,
}: TwoIconsWithTextProps) => {
  return (
    <div className={css(baseContainerStyles, containerOverride)}>
      <div className={css(baseIconRowStyles, iconsOverride)}>
        <div
          className={css(
            {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              flexShrink: 0,
              backgroundColor: 'neutrals.fill_quinary',
            },
            leftIconOverride,
          )}
        >
          {leftIcon}
        </div>

        {rightIcon && <FilledArrowRight size={24} aria-hidden />}

        {rightIcon && <div className={iconCircleStyles}>{rightIcon}</div>}
      </div>

      {title && <p className={css(baseTitleStyles, titleOverride)}>{title}</p>}

      {subtitle && (
        <p className={css(baseSubtitleStyles, subtitleOverride)}>{subtitle}</p>
      )}
    </div>
  );
};
